import React from 'react'
import FilterRowDropdown from './FilterRowDropdown'
import FilterRangeSlider from './FilterRangeSlider'
import PropTypes from 'prop-types'
import './SliderDropdown'

const SliderDropdown = props => {
  return (
    <FilterRowDropdown
      additionalClassNames={['SliderDropdown']}
      open={props.open}
      onAfterClose={props.onAfterClose}
      noSlideAnimation={props.noSlideAnimation}
      renderDropdownContent={() => {
        return (
          <div className='SliderDropdown__slider-container'>
            <FilterRangeSlider
              allowOverMax
              rangeMin={props.rangeMin}
              rangeMax={props.rangeMax}
              values={props.values}
              step={10}
              onChange={props.onChange}
              onSlideEnd={props.onSlideEnd}
              lightVersion={props.lightVersion}
            />
          </div>
        )
      }}
    />
  )
}

SliderDropdown.propTypes = {
  open: PropTypes.bool,
  noSlideAnimation: PropTypes.bool,
  rangeMax: PropTypes.number,
  rangeMin: PropTypes.number,
  values: PropTypes.object,
  onChange: PropTypes.func,
  onSlideEnd: PropTypes.func,
  onAfterClose: PropTypes.func,
  lightVersion: PropTypes.bool
}

export default SliderDropdown
